export default {
  HOUR_12: '12-HOUR',
  HOUR_24: '24-HOUR'
}